import React from 'react';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import CustomerStore from '../../stores/CustomerStore';
import AccountSettings from '../../components/AccountSettings';
import Helmet from 'react-helmet';
import Navbar from '../../components/Navbar';
import banquetLogoPng from '../../components/images/banquet_logo_2x.png';
import banquetLogoSvg from '../../components/images/banquet_logo.svg';
import styles from './index.sass';

class AccountSettingsContainer extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  getHelmetProps() {
    let { store, currentRoute } = this.props;
    let title = 'Account Settings';
    if(store) {
      title += ` – ${store.name}`;
    }
    return {
      title: title,
      meta: []
    };
  }

  render() {
    let { currentRoute, customer, store, requestStatus, error } = this.props;
    let accountSettingsProps = {
      customer: customer,
      store: store,
      requestStatus: requestStatus,
      error: error
    };

    return (
      <section className={styles.container} style={{paddingTop: store ? 100 : 0}}>
        <Helmet {...this.getHelmetProps()} />
        {store ? <img className={styles.banquetLogo} src={banquetLogoPng} srcSet={banquetLogoSvg} /> : null}
        <AccountSettings {...accountSettingsProps} />
      </section>
    );
  }
}

AccountSettingsContainer = connectToStores(AccountSettingsContainer, [CustomerStore], (context, props) => {
  let customerStore = context.getStore(CustomerStore);
  return {
    customer: customerStore.getCurrentCustomer(),
    requestStatus: customerStore.getCurrentRequestStatus(),
    error: customerStore.getCurrentError()
  };
});

export default AccountSettingsContainer;



// WEBPACK FOOTER //
// banquet/containers/AccountSettingsContainer/index.js